import { apiConst } from "@/lib/constant";
import { apiClient } from "@/lib/utils";

export async function getPromotionProducts(payLoad, locale) {
  const options = {
    method: "POST",
    body: JSON.stringify(payLoad),
  };
  try {
    const response = await apiClient({
      path: `${apiConst?.BASEURL}/${locale}/api/v1/line/item/skus/promotions`,
      options,
      cache: "no-store",
    });
    return response;
  } catch (error) {
    console.log(error);
    return {
      error,
    };
  }
}
